
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getBranchOrderList, getBranchOrderProgressList, getBranchOrderDetail, exportBranchOrdersData } from '@/api/branch';
import DialogOrderDetail from '@/components/OrderDetail/index.vue';
import DialogBranch from './components/BranchDialog.vue';
import DialogSelectedBranchServicer from './components/BranchServicer.vue';
import DialogImgLarge from '@/components/ImgLarge/index.vue';
import { getOrderServiceBranchOrderList } from '@/api/orderService';

@Component({
  name: 'BranchOrderServicer',
  components: {
    DialogOrderDetail,
    DialogBranch,
    DialogImgLarge,
    DialogSelectedBranchServicer
  }
})
export default class extends Vue {
  private formSearch: any = {
    addtimeRange: '',
    overtimeRange: '',
    ordernumber: '',
    branch: ''
  }
  private pickerOptions:any = {
    shortcuts: [{
      text: '今天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); //
        const end = new Date(today); 
        const start = new Date(today); 
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '昨天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick(picker: any) {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick(picker: any) {
     const today = new Date();
        today.setHours(0, 0, 0, 0); 
        const end = new Date(today); 
        const start = new Date(today); 
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  private total = 0;
  private listQuery: any = {
    page: 1,
    size: 10,
    name: '',
    orderNum: '',
    servicer: '',

    addtimeRange: '',
    overtimeRange: ''
  };

  created() {
    this.getOrderList();
  }

  handleSearch() {
    this.listQuery.name = this.formSearch.branch;
    this.listQuery.orderNum = this.formSearch.ordernumber;
    this.listQuery.startTimeAdd = this.formSearch.addtimeRange[0];
    this.listQuery.endTimeAdd = this.formSearch.addtimeRange[1];
    this.listQuery.startTimeOver = this.formSearch.overtimeRange[0];
    this.listQuery.endTimeOver = this.formSearch.overtimeRange[1];
    this.listQuery.page = 1;
  }

  handleClearSearch() {
    this.listQuery.name = '';
    this.listQuery.orderNum = '';
    this.listQuery.addtimeRange = '';
    this.listQuery.overtimeRange = '';
    this.listQuery.servicer = '';
    this.formSearch.branch = '';
    this.formSearch.ordernumber = '';

    this.formSearch.addtimeRange = '';
    this.formSearch.overtimeRange = '';
    this.listQuery.page = 1;
  }

  handleCurrentChange(val: number) {
    this.listQuery.page = val;
  }

  handleSizeChange(val: number) {
    this.listQuery.size = val;
  }

  private dialogSelectBranchServicerVisible = false
  private handleSelectBranchServicer(row: any) {
    this.branchVisible = false;
    // this.formSearch.servicer.id = row.id;
    this.formSearch.servicer.name = row.name;
  }
  private closeSelectBranchServicer(value: boolean) {
    this.dialogSelectBranchServicerVisible = value;
  }

  private dialogOrderDetailVisible = false
  private detail = {
    order: {
      reminder: {}
    },
    order_service: { transfer_out_from: {} },
    order_quote: {}
  }
  private isOrderProgress = false;
  private showComplaintBtn=false;
  private orderProgressData = {};

  detailHandle(row: any, index: number) {
    this.dialogOrderDetailVisible = true;
    const pparams = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      branch_company_id: row.order.customer_company_id,
      order_id: row.order.id
    };
    getBranchOrderDetail(pparams).then(res => {
      const data = res.data;
      if (data !== null) {
        this.detail = res.data;
      }
    }).catch(err => {
      let msg = err.msg;
    });

    // 订单进度
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      branch_company_id: row.order.customer_company_id,
      order_id: row.order.id
    };
    getBranchOrderProgressList(params).then(res => {
      const data = res.data;
      if (data !== null) {
        this.orderProgressData = data;
      } else {
        this.orderProgressData = {};
      }
    }).catch(err => {
      this.orderProgressData = {};
      this.showErrorMsg(err.msg);
    });

    if (index === 2) {
      this.isOrderProgress = true;
    } else {
      this.isOrderProgress = false;
    }
  }
  closeDetailHandle(value: boolean) {
    this.dialogOrderDetailVisible = value;
  }

  private selectedServicerHandle() {
    this.dialogSelectBranchServicerVisible = true;
  }

  private listLoading = true;
  private orderList = []

  private getOrderList() {
    const startTime = Date.parse(this.listQuery.startTime) / 1000;
    const endTime = Date.parse(this.listQuery.endTime) / 1000;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      branch_company_name: this.listQuery.name,
      servicer_company_name: this.listQuery.servicer,
      order_num: this.listQuery.orderNum,
      start_time: isNaN(startTime) ? '' : startTime,
      end_time: isNaN(endTime) ? '' : endTime,
      page: this.listQuery.page,
      size: this.listQuery.size
    };
    getOrderServiceBranchOrderList(params).then(res => {
      this.listLoading = false;
      if (res && res.data) {
        this.orderList = res.data.list;
        this.total = res.data.count;
      } else {
        this.orderList = [];
        this.total = 0;
      }
    }).catch(err => {
      this.listLoading = false;
      let msg = err.msg;
    });
  }

  getTagsHtml(r:any) {
    let kind = ''; let kindType = ''; let plain = 'plain';
    if (parseInt(r.order.order_type) === 1) {
      kind = '其他';
      kindType = 'warning';
    } else if (parseInt(r.order.order_type) === 2) {
      kind = '维保';
      kindType = 'success';
    } else if (parseInt(r.order.order_type) === 3) {
      kind = '安装';
      kindType = 'danger';
    } else if (parseInt(r.order.order_type) === 4) {
      kind = '巡检';
      kindType = '';
    } else {
      kind = '维保';
      kindType = 'success';
    }

    let charge = ''; let darkplain = 'dark';
    if (parseInt(r.order_service.charge) === 1) {
      charge = '收费';
    }

    let expedited = '';
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = '加急';
    }

    // 审核标识
    let check = '';
    if (parseInt(r.order.check_state) === 11 || parseInt(r.order.check_state) === 51) {
      check = '审核';
    }

    return [{
      type: kindType, label: kind, plain: plain
    }, {
      type: 'danger', label: charge, plain: darkplain
    }, {
      type: 'danger', label: expedited, plain: darkplain
    }, {
      type: 'warning', label: check, plain: darkplain
    }];
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }

  private branchVisible = false
  private selectBranchHandle() {
    this.branchVisible = true;
  }
  closeBranchHandle(value: boolean) {
    this.branchVisible = value;
  }
  handleSelectedBanch(row: any) {
    // this.branchVisible = false;
    // this.formSearch.branches.id = row.id;
    // this.formSearch.branches.name = row.name;
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
}
